module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Temperature-full-65f36a4d6b3d597f0d772303df1de17b.svg";